// extracted by mini-css-extract-plugin
export default {"-large":"Oidjzfi_SiHi4H9nVHHb","dot":"mgIRLhvZuMMrsLoqT_04","active":"RgoeW8bAhOTmb2jLUFsR"};